import cx from 'classnames'
import type React from 'react'
import type { FC } from 'react'

import { IconInfo } from '../../icons'
import css from './Info.module.scss'

type Props = {
  children?: React.ReactNode
  className?: string
  withIcon?: boolean
}

const Info: FC<Props> = ({ children, className, withIcon }) => (
  <div className={cx(css.container, className)}>
    {withIcon && <IconInfo className={css.icon} />}
    {children}
  </div>
)

export default Info
